import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.929 1.277h-5.11a2.676 2.676 0 0 0-2.67 2.67v8.18a2.676 2.676 0 0 0 2.67 2.67h6.36a2.676 2.676 0 0 0 2.67-2.67v-6.24h.01V5.2Zm2.42 10.85a1.171 1.171 0 0 1-1.17 1.17h-6.36a1.178 1.178 0 0 1-1.17-1.17v-8.18a1.178 1.178 0 0 1 1.17-1.17h4.43v3.11h3.1Zm-2.29-3.15a.754.754 0 0 1-.32.62l-2.62 1.82a.749.749 0 0 1-.43.13.808.808 0 0 1-.34-.08.76.76 0 0 1-.41-.67v-3.64a.76.76 0 0 1 .41-.67.737.737 0 0 1 .77.05l2.62 1.83a.749.749 0 0 1 .32.61Z';
const draw24px =
  'M14.75,14a.75.75,0,0,1-.32.61l-4,2.78a.76.76,0,0,1-.43.14.73.73,0,0,1-.35-.09.75.75,0,0,1-.4-.66V11.21a.75.75,0,0,1,1.18-.61l4,2.79A.75.75,0,0,1,14.75,14Zm6-6.37V18.37A3.76,3.76,0,0,1,17,22.12H7.06a3.76,3.76,0,0,1-3.75-3.75V5.63A3.76,3.76,0,0,1,7.06,1.88H15Zm-1.5,1H14V3.38H7.06A2.25,2.25,0,0,0,4.81,5.63V18.37a2.25,2.25,0,0,0,2.25,2.25H17a2.25,2.25,0,0,0,2.25-2.25Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DocumentVideoIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'documentVideo')) as IconWithRender;

DocumentVideoIcon.displayName = 'DocumentVideoIcon';
DocumentVideoIcon.propTypes = Icon.propTypes;
DocumentVideoIcon.renderIcon = (props) => <DocumentVideoIcon {...props} />;
export default DocumentVideoIcon;
